import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import * as EventsActionCreators from '../../redux/events';
import * as UiActionsCreators from '../../redux/ui';
import * as OrganizationsActionCreators from '../../redux/organizations';
import * as BusinessMetricsActionCreators from '../../redux/businessMetrics';
import moment from 'moment-timezone';

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  > div {
    flex: calc(50% - 10px) 0 0;
    margin-top: 20px;
  }
`;
const InfoContainer = styled.div`
  color: white;
  background: #48484d;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  > h4 {
    margin: 0;
    text-align: center;
    font-size: 28px;
  }
  div:first-child {
    border-right: 1px solid white;
  }
`;

const InfoContainerInnerWrapper = styled.div`
  text-align: center;
  display: flex;
  > div {
    flex: 50% 0 0;
  }
  h4 {
    font-size: 50px;
    margin-bottom: 5px;
    margin-top: 0px;
    font-weight: 200;
  }
  h5 {
    font-size: 24px;
    margin: 0;
    font-weight: lighter;
  }
`;
const Wrapper = styled.div`
  background: #363638;
  padding: 20px;
  width: calc(100% - 15px);
  margin-top: -15px;
  height: calc(100vh - 105px);
  display: flex;
  flex-direction: column;
  > div {
    flex: 1;
  }
`;

const THIS_MONDAY = moment().startOf('isoWeek');
const LAST_MONDAY = moment()
  .startOf('isoWeek')
  .subtract(7, 'days');
const LAST_SUNDAY = moment()
  .startOf('isoWeek')
  .subtract(1, 'days');
const MOMENT_TODAY = moment()
  .local()
  .hour(0)
  .minute(0)
  .second(0)
  .millisecond(0)
  .add(1, 'days');

function formatDate(date, format = 'D MMM YYYY (ddd)') {
  if (moment(date).isValid()) {
    return moment
      .utc(date)
      .local()
      .format(format);
  }
  return '';
}

const CREATED_AT_MAPPING = {
  'this-week': {
    '>=': formatDate(THIS_MONDAY, 'YYYY-MM-DD'),
    '<=': formatDate(MOMENT_TODAY, 'YYYY-MM-DD')
  },
  'last-week': {
    '>=': formatDate(LAST_MONDAY, 'YYYY-MM-DD'),
    '<=': formatDate(LAST_SUNDAY, 'YYYY-MM-DD')
  }
};
class BusinessMetrics extends Component {
  state = { lastweekOrgs: [], thisweekOrgs: [] };

  async componentDidMount() {
    const { actions } = this.props;

    const promises = [
      actions.getEventsCount(),
      actions.getOrganizationsBusinessMetrics()
    ];
    promises.push(
      actions.getOrganizationsBusinessMetrics(
        JSON.stringify({ created_at: CREATED_AT_MAPPING['last-week'] })
      )
    );
    promises.push(
      actions.getOrganizationsBusinessMetrics(
        JSON.stringify({ created_at: CREATED_AT_MAPPING['this-week'] })
      )
    );
    promises.push(
      actions.getOrganizationsBusinessMetrics(
        JSON.stringify({
          organization_members_created_at: CREATED_AT_MAPPING['last-week'],
          withMembersOnly: true
        })
      )
    );
    promises.push(
      actions.getOrganizationsBusinessMetrics(
        JSON.stringify({
          organization_members_created_at: CREATED_AT_MAPPING['this-week'],
          withMembersOnly: true
        })
      )
    );
    promises.push(
      actions.getOrganizationsBusinessMetrics(
        JSON.stringify({
          event_guests_created_at: CREATED_AT_MAPPING['last-week'],
          withticketsSold: true
        })
      )
    );
    promises.push(
      actions.getOrganizationsBusinessMetrics(
        JSON.stringify({
          event_guests_created_at: CREATED_AT_MAPPING['this-week'],
          withticketsSold: true
        })
      )
    );
    promises.push(
      actions.getOrganizationsBusinessMetrics(
        JSON.stringify({ withcreditCards: true })
      )
    );
    promises.push(
      actions.getOrganizationsBusinessMetrics(
        JSON.stringify({
          stripe_cards_created_at: CREATED_AT_MAPPING['this-week'],
          withcreditCards: true
        })
      )
    );
    const result = await Promise.all(promises);
    const totalOrgs = result[1];
    const lastweekOrgs = result[2];
    const thisweekOrgs = result[3];
    const lastweekOrgsWithMembers = result[4];
    const thisweekOrgsWithMembers = result[5];
    const lastweekOrgsWithTicketSold = result[6];
    const thisweekOrgsWithticketSOld = result[7];
    const orgsWithCards = result[8];
    const orgsWithCardsThisWeek = result[9];
    this.setState({
      lastweekOrgs,
      thisweekOrgs,
      lastweekOrgsWithMembers,
      thisweekOrgsWithMembers,
      lastweekOrgsWithTicketSold,
      thisweekOrgsWithticketSOld,
      orgsWithCards,
      orgsWithCardsThisWeek,
      totalOrgs
    });
  }

  render() {
    const { eventsCount } = this.props;
    const {
      totalOrgs,
      lastweekOrgs,
      thisweekOrgs,
      lastweekOrgsWithMembers,
      thisweekOrgsWithMembers,
      lastweekOrgsWithTicketSold,
      thisweekOrgsWithticketSOld,
      orgsWithCards,
      orgsWithCardsThisWeek
    } = this.state;
    return (
      <Wrapper>
        <InfoContainer>
          <h4>All time Performance</h4>
          <InfoContainerInnerWrapper>
            <div>
              <h4>{eventsCount ? eventsCount.count : '-'}</h4>
              <h5>Events</h5>
            </div>
            <div>
              <h4>{totalOrgs ? totalOrgs.count : '-'}</h4>
              <h5>Organizations</h5>
            </div>
          </InfoContainerInnerWrapper>
        </InfoContainer>
        <Flex>
          <InfoContainer>
            <h4>Organizations added</h4>
            <InfoContainerInnerWrapper>
              <div>
                <h4>{lastweekOrgs ? lastweekOrgs.count : '-'}</h4>
                <h5>Last week</h5>
              </div>
              <div>
                <h4>{thisweekOrgs ? thisweekOrgs.count : '-'}</h4>
                <h5>This week</h5>
              </div>
            </InfoContainerInnerWrapper>
          </InfoContainer>
          <InfoContainer>
            <h4>Active billing via credit card</h4>
            <InfoContainerInnerWrapper>
              <div>
                <h4>{orgsWithCards ? orgsWithCards.count : '-'}</h4>
                <h5>Organizations</h5>
              </div>
              <div>
                <h4>
                  {orgsWithCardsThisWeek ? orgsWithCardsThisWeek.count : '-'}
                </h4>
                <h5>Added this week</h5>
              </div>
            </InfoContainerInnerWrapper>
          </InfoContainer>
        </Flex>
        <Flex>
          <InfoContainer>
            <h4>Organizations with tickets sold</h4>
            <InfoContainerInnerWrapper>
              <div>
                <h4>
                  {lastweekOrgsWithTicketSold
                    ? lastweekOrgsWithTicketSold.count
                    : '-'}
                </h4>
                <h5>Last week</h5>
              </div>
              <div>
                <h4>
                  {thisweekOrgsWithticketSOld
                    ? thisweekOrgsWithticketSOld.count
                    : '-'}
                </h4>
                <h5>This week</h5>
              </div>
            </InfoContainerInnerWrapper>
          </InfoContainer>
          <InfoContainer>
            <h4>Organizations with member added</h4>
            <InfoContainerInnerWrapper>
              <div>
                <h4>
                  {lastweekOrgsWithMembers
                    ? lastweekOrgsWithMembers.count
                    : '-'}
                </h4>
                <h5>Last week</h5>
              </div>
              <div>
                <h4>
                  {thisweekOrgsWithMembers
                    ? thisweekOrgsWithMembers.count
                    : '-'}
                </h4>
                <h5>This week</h5>
              </div>
            </InfoContainerInnerWrapper>
          </InfoContainer>
        </Flex>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  businessMetrics: state.businessMetrics.businessMetrics,
  eventsCount: state.events.eventsCount,
  ui: state.ui.uiState
});

const ActionCreators = Object.assign(
  {},
  UiActionsCreators,
  EventsActionCreators,
  OrganizationsActionCreators,
  BusinessMetricsActionCreators
);

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(ActionCreators, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessMetrics);



// WEBPACK FOOTER //
// ./src/pages/business-metrics/index.js